"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeCrossChainSwap = exports.decodeCrossChainSwap = exports.messagesType = void 0;
const web3_1 = __importDefault(require("web3"));
const abiUtils = new web3_1.default().eth.abi;
exports.messagesType = {
    swapAndUnwrap: [
        {
            name: "functionType",
            type: "string",
        },
        {
            name: "uniqueCounter",
            type: "uint256",
        },
        {
            name: "sourceChainId",
            type: "uint256",
        },
        {
            name: "user",
            type: "address",
        },
        {
            name: "exchangeConnector",
            type: "address",
        },
        {
            name: "amount",
            type: "uint256",
        },
        {
            name: "isFixedToken",
            type: "bool",
        },
        {
            name: "path",
            type: "address[]",
        },
        {
            components: [
                {
                    name: "userScript",
                    type: "bytes",
                },
                {
                    name: "scriptType",
                    type: "uint8",
                },
                {
                    name: "lockerLockingScript",
                    type: "bytes",
                },
            ],
            name: "scripts",
            type: "tuple",
        },
        {
            name: "thirdPartyId",
            type: "uint256",
        },
    ],
    swapAndUnwrapRune: [
        {
            name: "functionType",
            type: "string",
        },
        {
            name: "uniqueCounter",
            type: "uint256",
        },
        {
            name: "sourceChainId",
            type: "uint256",
        },
        {
            name: "user",
            type: "address",
        },
        {
            name: "appId",
            type: "uint256",
        },
        {
            name: "amount",
            type: "uint256",
        },
        {
            name: "internalId",
            type: "uint256",
        },
        {
            name: "path",
            type: "address[]",
        },
        {
            components: [
                {
                    name: "userScript",
                    type: "bytes",
                },
                {
                    name: "scriptType",
                    type: "uint8",
                },
            ],
            name: "scripts",
            type: "tuple",
        },
        {
            name: "thirdPartyId",
            type: "uint256",
        },
    ],
};
function decodeCrossChainSwap(data) {
    return abiUtils.decodeParameters(exports.messagesType.swapAndUnwrap, data);
}
exports.decodeCrossChainSwap = decodeCrossChainSwap;
function encodeCrossChainSwap(uniqueCounter, sourceChainId, user, exchangeConnector, amount, isFixedToken, path, userScript, scriptType, lockerLockingScript, thirdPartyId) {
    return abiUtils.encodeParameters(exports.messagesType.swapAndUnwrap, [
        "swapAndUnwrap",
        uniqueCounter,
        sourceChainId,
        user,
        exchangeConnector,
        amount,
        isFixedToken,
        path,
        [userScript, scriptType, lockerLockingScript],
        thirdPartyId,
    ]);
}
exports.encodeCrossChainSwap = encodeCrossChainSwap;
//# sourceMappingURL=crosschain-helper.js.map